import { FC } from 'react';
import { react2angular } from 'react2angular';
import styled from 'styled-components';
import MessageBar from '@splunk/react-ui/MessageBar';
import { variables } from '@splunk/themes';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../../common/theme/ThemeProvider';

type ApmOldWizardSunsetBannerProps = {
    redirectLink?: string;
    variant: 'newDetector' | 'existingDetector';
};

const StyledMessageBar = styled(MessageBar)`
    grid-template-columns:
        [icon] 20px
        ${variables.spacingSmall}
        [content] minmax(0, 1fr)
        [close] min-content;

    & [data-test='content'] {
        max-width: 100%;
        min-width: 0;
    }
`;

const StyledLink = styled.a`
    color: inherit;
    font-weight: ${variables.fontWeightBold};
    text-decoration: underline;
`;

export const ApmOldWizardSunsetBanner: FC<ApmOldWizardSunsetBannerProps> = ({
    redirectLink,
    variant,
}): JSX.Element => {
    const themeKey = useLegacyThemeServiceKey();

    return (
        <ThemeProvider colorScheme={themeKey}>
            <StyledMessageBar data-test="apm-old-wizard-sunset-banner" type="warning">
                {variant === 'existingDetector' ? (
                    <>
                        This builder will be replaced by new APM wizard/signalflow builder after{' '}
                        January 2027.{' '}
                        {redirectLink && (
                            <StyledLink href={redirectLink}>
                                Continue in that experience.
                            </StyledLink>
                        )}
                    </>
                ) : (
                    'This builder will be replaced by new APM wizard after January 2027.'
                )}
            </StyledMessageBar>
        </ThemeProvider>
    );
};

export const apmOldWizardSunsetBanner = react2angular(ApmOldWizardSunsetBanner, [
    'redirectLink',
    'variant',
]);
